enum AuthenticationFormStep {
    EMAIL_CHECK,
    SIGN_IN,
}

export default AuthenticationFormStep;
